import type { SVGProps } from "react";
import { memo, useRef } from "react";

const HelpIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props}>
      <path
        fill="#00357A"
        d="M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14-6.268 14-14 14Zm0-2.8a11.2 11.2 0 1 0 0-22.4 11.2 11.2 0 0 0 0 22.4Zm-1.4-7h2.8V21h-2.8v-2.8Zm2.8-2.303v.903h-2.8v-2.1a1.4 1.4 0 0 1 1.4-1.4 2.1 2.1 0 1 0-2.06-2.512l-2.746-.55a4.901 4.901 0 1 1 6.206 5.659Z"
      />
    </svg>
  );
};

const Memo = memo(HelpIcon)
export { Memo as HelpIcon }
